import "./AiFloatingAssistant.css";

function Robot() {

    return (

        <svg
            className="robot-svg"
            viewBox="0 0 220 260"
            xmlns="http://www.w3.org/2000/svg"
        >

            <defs>

                <linearGradient id="bodyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#7c3aed" />
                    <stop offset="100%" stopColor="#4f46e5" />
                </linearGradient>

                <radialGradient id="coreGlow">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="100%" stopColor="#8b5cf6" />
                </radialGradient>

                <filter id="shadow">
                    <feDropShadow
                        dx="0"
                        dy="8"
                        stdDeviation="10"
                        floodColor="#4f46e5"
                        floodOpacity=".25"
                    />
                </filter>

            </defs>

            {/* Shadow */}

            <ellipse
                className="robot-shadow"
                cx="110"
                cy="244"
                rx="42"
                ry="12"
            />

            <g className="robot-wrapper">

                {/* Antenna */}

                <line
                    x1="110"
                    y1="24"
                    x2="110"
                    y2="42"
                    stroke="#9CA3AF"
                    strokeWidth="4"
                    strokeLinecap="round"
                />

                <circle
                    className="robot-antenna-light"
                    cx="110"
                    cy="18"
                    r="8"
                    fill="#7C3AED"
                />

                {/* Head */}

                <rect
                    x="60"
                    y="42"
                    rx="26"
                    ry="26"
                    width="100"
                    height="80"
                    fill="white"
                    filter="url(#shadow)"
                />

                {/* Eyes */}

                <ellipse
                    className="robot-eye left-eye"
                    cx="90"
                    cy="78"
                    rx="6"
                    ry="6"
                    fill="#4F46E5"
                />

                <ellipse
                    className="robot-eye right-eye"
                    cx="130"
                    cy="78"
                    rx="6"
                    ry="6"
                    fill="#4F46E5"
                />

                {/* Smile */}

                <path
                    d="M92 97 Q110 110 128 97"
                    stroke="#4F46E5"
                    strokeWidth="4"
                    fill="none"
                    strokeLinecap="round"
                />

                {/* Left Arm */}

                <g className="left-arm">

                    <rect
                        x="35"
                        y="132"
                        width="16"
                        height="58"
                        rx="8"
                        fill="#D1D5DB"
                    />

                    <circle
                        cx="43"
                        cy="194"
                        r="9"
                        fill="#E5E7EB"
                    />

                </g>

                {/* Right Arm */}

                <g className="right-arm">

                    <rect
                        x="169"
                        y="132"
                        width="16"
                        height="58"
                        rx="8"
                        fill="#D1D5DB"
                    />

                    <circle
                        cx="177"
                        cy="194"
                        r="9"
                        fill="#E5E7EB"
                    />

                </g>

                {/* Body */}

                <rect
                    x="74"
                    y="120"
                    width="72"
                    height="88"
                    rx="24"
                    fill="url(#bodyGradient)"
                    filter="url(#shadow)"
                />

                {/* AI Core */}

                <g className="robot-core">

                    <circle
                        cx="110"
                        cy="164"
                        r="15"
                        fill="url(#coreGlow)"
                    />

                </g>

                {/* Legs */}

                <g className="left-leg">

                    <rect
                        x="88"
                        y="206"
                        width="12"
                        height="34"
                        rx="6"
                        fill="#9CA3AF"
                    />

                </g>

                <g className="right-leg">

                    <rect
                        x="120"
                        y="206"
                        width="12"
                        height="34"
                        rx="6"
                        fill="#9CA3AF"
                    />

                </g>

            </g>

        </svg>

    );

}

export default Robot;